// components/ProtectedRoute.jsx
import { Navigate } from "react-router-dom";
import api from '../config/api';

export default function ProtectedRoute({ children }) {
  const token = localStorage.getItem("token");

  if (!token) {
    return <Navigate to="/" replace />;
  }

  return children;
}
